import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {FinalReportsComponent} from './final-reports/final-reports.component';
import {RouterModule} from '@angular/router';
import {PracticeRoundReportsComponent} from './practice-round-reports/practice-round-reports.component';
import {RoundOneReportsComponent} from './round-one-reports/round-one-reports.component';
import {RoundTwoReportsComponent} from './round-two-reports/round-two-reports.component';
import {RegistrationReportsComponent} from './registration-reports/registration-reports.component';
import {DataTablesModule} from 'angular-datatables';
import {DataTableModule, TreeTableModule, } from 'primeng/primeng';
import {TableModule} from 'primeng/table';
import { DiversityReportsComponent } from './diversity-reports/diversity-reports.component';
import { DreamUniversityReportComponent } from './dream-university-report/dream-university-report.component';

@NgModule({
    declarations: [
        FinalReportsComponent,
        PracticeRoundReportsComponent,
        RoundOneReportsComponent,
        RoundTwoReportsComponent,
        RegistrationReportsComponent,
        DiversityReportsComponent,
        DreamUniversityReportComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        DataTablesModule,
        DataTableModule,
        TreeTableModule,
        TableModule,

    ]
})
export class ReportsModule {
}
